import { forwardRef, LegacyRef, PropsWithChildren, useEffect, useState } from 'react'
import { DropDownList, DropDownListBlurEvent, DropDownListChangeEvent, DropDownListFilterChangeEvent, DropDownListHandle } from '@progress/kendo-react-dropdowns';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from "@progress/kendo-data-query";
import { ZIndexContext } from "@progress/kendo-react-common";
import { FloatingLabel } from 'react-bootstrap';
import { DropdownOption } from './DropdownOption';

interface SearchableDropdownProps extends PropsWithChildren {
  label: string;
  name: string;
  isInvalid?: boolean;
  className?: string;
  options: DropdownOption[];
  defaultItem?: DropdownOption;
  value?: DropdownOption;
  includeAll?: boolean;
  filterFields?: string[];
  onChange?: (e: DropDownListChangeEvent) => void;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  disabled?: boolean;
  itemRender?: any;
}

export const SearchableDropdown = forwardRef(
  (
    props: Readonly<SearchableDropdownProps>,
    ref: LegacyRef<DropDownListHandle> | undefined
  ) => {
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const [allData, setAllData] = useState<DropdownOption[]>([]);
  const filterData = (filter: FilterDescriptor | CompositeFilterDescriptor) => {
    const data = allData;
    return filterBy(data, filter);
  };
  const filterChange = (event: DropDownListFilterChangeEvent) => {
    if (props.filterFields && props.filterFields.length > 0) {
      const filter: CompositeFilterDescriptor = {
        logic: "or",
        filters: props.filterFields.map((field) => ({ ...event.filter, field })),
      };
      setOptions(filterData(filter));
      return;
    }
    setOptions(filterData(event.filter));
  };

  useEffect(() => {
    setOptions(props.options);
    setAllData(props.options);
  }, [props.options]);

  return (
    <FloatingLabel
      className="mb-3 h-100 floating-label-fixed"
      label={`${props.label}`}
      style={{ "color": "rgba(var(--bs-body-color-rgb), 0.65)" }}>
      <ZIndexContext.Provider value={10000}>
        <DropDownList
          ref={ref}
          name={props.name}
          className={`w-100 h-100 k-rounded-xxl bg-transparent ${props.isInvalid ? 'k-invalid is-invalid' : ''} ${props.className}`}
          data={options}
          textField="text"
          title={props.label}
          dataItemKey="value"
          value={props.value}
          defaultItem={props.defaultItem}
          filterable={true}
          onFilterChange={filterChange}
          onChange={(e) => {
            props.onChange && props.onChange(e);
            props.onSelect && props.onSelect(e.target.value as DropdownOption);
          }}
          onBlur={props.onBlur}
          disabled={props.disabled}
          itemRender={props.itemRender}
        />
      </ZIndexContext.Provider>
      {props.children}
    </FloatingLabel>
  )
});

export default SearchableDropdown
